import { api } from "@/redux/api";

import {
	SearchProfilePreset,
	SearchProfilePresetDeleteResponse,
	SearchProfilePresetDeleteResponseSchema,
	SearchProfilePresetListResponse,
	SearchProfilePresetListResponseSchema,
	SearchProfilePresetSchema,
} from "./searchProfilePreset.schema";

export const searchProfilePresetApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getSearchProfilePresets: builder.query<SearchProfilePresetListResponse, void>({
			query: () => ({
				url: "search-profile-presets",
				responseSchema: SearchProfilePresetListResponseSchema,
			}),
			providesTags: ["SearchProfilePreset"],
		}),
		createSearchProfilePreset: builder.mutation<
			SearchProfilePreset,
			{ name: string; config: Record<string, unknown> }
		>({
			query: (body) => ({
				url: "search-profile-presets",
				method: "POST",
				body,
				responseSchema: SearchProfilePresetSchema,
			}),
			invalidatesTags: ["SearchProfilePreset"],
		}),
		updateSearchProfilePreset: builder.mutation<
			SearchProfilePreset,
			{ id: number; name?: string; config?: Record<string, unknown> }
		>({
			query: ({ id, ...body }) => ({
				url: `search-profile-presets/${id}`,
				method: "PUT",
				body,
				responseSchema: SearchProfilePresetSchema,
			}),
			invalidatesTags: ["SearchProfilePreset"],
		}),
		deleteSearchProfilePreset: builder.mutation<SearchProfilePresetDeleteResponse, number>({
			query: (id) => ({
				url: `search-profile-presets/${id}`,
				method: "DELETE",
				responseSchema: SearchProfilePresetDeleteResponseSchema,
			}),
			invalidatesTags: ["SearchProfilePreset"],
		}),
	}),
});

export const {
	useGetSearchProfilePresetsQuery,
	useCreateSearchProfilePresetMutation,
	useUpdateSearchProfilePresetMutation,
	useDeleteSearchProfilePresetMutation,
} = searchProfilePresetApi;
